import {FiFacebook, FiInstagram} from "react-icons/fi";
import React from "react";
import {AiOutlineX} from "react-icons/ai";

export default function RenderPostType({type}) {
    switch (type) {
        case "instagram-post":
            return <span className={"post-badge"} style={{fontSize:14, backgroundColor:'#E1306C'}}><FiInstagram /> Post</span>
        case "instagram-reel":
            return <span className={"post-badge"} style={{fontSize:14, backgroundColor:'#E1306C'}}><FiInstagram /> Reel</span>
        case "instagram-story":
            return <span className={"post-badge"} style={{fontSize:14, backgroundColor:'#E1306C'}}><FiInstagram /> Story</span>
        case "facebook-page-post":
            return <span className={"post-badge"} style={{fontSize:14, backgroundColor:'#1877F2'}}><FiFacebook /> Post</span>
        case "facebook-page-reel":
            return <span className={"post-badge"} style={{fontSize:14, backgroundColor:'#1877F2'}}><FiFacebook /> Reel</span>
        case "facebook-page-story":
            return <span className={"post-badge"} style={{fontSize:14, backgroundColor:'#1877F2'}}><FiFacebook /> Story</span>
        case "twitter-post":
            return <span className={"post-badge"} style={{fontSize:14, backgroundColor:'#1DA1F2'}}><AiOutlineX /> Tweet</span>
    }

}
